import { render } from "./ProductList.vue?vue&type=template&id=a58838aa"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=a58838aa&lang=css"

import exportComponent from "/home/collin/workspace/elands/elandsweb/main-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__